import React, { useEffect, useState } from 'react';
import FireFetch from "../../Firebase/FireFetch";
import { message, Form, Input, Select, Radio, DatePicker, Divider, Checkbox, Skeleton } from "antd";
import { Button } from "evergreen-ui";
import { MDBCol } from "mdbreact";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { useAuthState } from 'react-firebase-hooks/auth';
import { getDatabase, ref, update } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { useAuth } from "../../AuthContext/AuthContext";
import { isActiveUserStatus } from "../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions";


const { TextArea } = Input;
var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
const moment = require("moment");
var storage = getStorage(Firebase);
const EditGroup = (props) => {
	const { canAccessModule } = useAuth();
	const canUpdateGroup = canAccessModule("GROUPS", "update");
	const [user] = useAuthState(auth);
	const [form] = Form.useForm();
	const [showLoading, setShowLoading] = useState(false);
	const [groups, groupsLoading] = useListVals(ref(db, "talmidsdb/groups"));
	const [users, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
	const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
	const [orgArray, orgsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [languages, languagesLoading] = useListVals(ref(db, "talmidsdb/languages"));
	const [countries, countriesLoading] = useListVals(ref(db, "talmidsdb/countries"));
	const [districts, districtsLoading] = useListVals(ref(db, "talmidsdb/district"));
	const marketDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	const [radioValue, setRadioValue] = useState(0);
	const [userArray, setUserArray] = useState([]);
	const [languageArray, setLanguageArray] = useState([]);
	const [notListed, setNotListed] = useState(false);
	const [notListed2, setNotListed2] = useState(false);
	const [selectedType, setSelectedType] = useState([])
	const [checkTypeList, setCheckTypeList] = useState([]);
	const [groupTypes, groupTypesLoading] = useListVals(ref(db, "talmidsdb/groupTypes"));
	const [filesList, setFilesList] = useState([]);
	const isLookupLoading =
		groupsLoading ||
		usersLoading ||
		communitiesLoading ||
		orgsLoading ||
		languagesLoading ||
		countriesLoading ||
		districtsLoading ||
		groupTypesLoading;

	useEffect(() => {
		const filteredOptions = groupTypes?.filter(x => (x.typeID ?? x.id) !== props.group?.groupType) || [];
		filteredOptions?.map((item, index) => {
			filteredOptions[index]["label"] = item.typeName ?? item.type;
			filteredOptions[index]["value"] = item.id ?? item.typeID;
		});
		setCheckTypeList([...filteredOptions]);
		if (users) {
			var tempUserArray = users;
			tempUserArray.push({
				id: "Not Listed",
				firstname: "Not",
				surname: "Listed"
			});
			setUserArray(tempUserArray);
		}

		if (languages) {
			var tempLangArray = languages;
			tempLangArray.push({
				languageID: "Other",
				language: "Other"
			});
			setLanguageArray(tempLangArray);
		}
		if (user) {
			//console.log(user.uid);
		}
		form.resetFields();

	}, [users, languages, user, groupTypes, selectedType, form, props.group])

	const onRadioChange = (e) => {
		setRadioValue(e.target.value);
	};

	const onChange = (checkedValues) => {
		console.log('checked = ', checkedValues);
	};

	const handleFileUpload = (e) => {
		console.log(e.target.id);
		const fileObject = {
			"fileID": e.target.id,
			"file": e.target.files[0]
		}
		if (!filesList.includes(fileObject)) {
			var index = filesList.findIndex(x => x.fileID === fileObject.fileID);
			console.log(index);
			if (index != -1) {
				filesList.splice(index, 1);
				setFilesList(filesList => [...filesList, fileObject]);
			} else {
				setFilesList(filesList => [...filesList, fileObject]);
			}
		}
	}

	const communityChange = (option) => {
		const comm = communityArray?.find(x => x.communityID === option || x.id === option);
		if (!comm) return;
		const country = comm.countryID ?? comm.countryId ?? "";
		const district = comm.districtID ?? comm.district ?? "";
		form.setFieldsValue({
			country: country,
			district: district
		});

	}

	const editGroup = (values) => {
		if (!canUpdateGroup) {
			message.error("You do not have permission to update groups.");
			return;
		}

		setShowLoading(true);
		var dateModified = moment().format("YYYY-MM-DDTh:mm:ss");
		var communityName = communityArray.find(x => x.communityID === values.community)?.name;
		var typeName = groupTypes.find(x => x.typeID === values.groupType)?.type;

		var prefixName = communityName + "-" + typeName + "-" + values.genderDemographics;
		var filtered = groups?.filter(x => x.groupName.includes(prefixName));
		var number = filtered.length + 1;
		var groupName = prefixName + "-" + number;

		var groupObject = values;
		delete values.image1;
		delete values.image2;
		groupObject.dateModified = dateModified;
		groupObject.groupName = groupName;
		groupObject.groupStartDate = values.groupStartDate ? values.groupStartDate.format("YYYY") : "";
		groupObject.groupEndDate = values.groupEndDate ? values.groupEndDate.format("YYYY-MM-DD") : "";

		Object.entries(groupObject).forEach(([key, value]) => {
			if (value === undefined) {
				groupObject[key] = "";
			}
		});

		var groupID = props.group?.groupId;
		console.log(groupID);

		update(ref(db, "talmidsdb/groups/" + groupID), groupObject).then((result) => {
			FireFetch.addLog("Groups", groupID, "Edit");
			message.success("Group updated successfully");
			setShowLoading(false);
			form.resetFields();
			props.modal(false);
		})
			.catch((error) => {
				message.error(`Unable to update group. An error occurred : ${error.message}`);
				console.error(error)
				setShowLoading(false);
			})


		if (filesList.length !== 0) {
			var urlArray = [];
			filesList?.map((file, index) => {

				uploadBytes(storageRef(storage, `groups/${groupID}/image-${index}`), file.file).then((item) => {
					getDownloadURL(item.ref)
						.then((url) => {
							urlArray.push(url);
							console.log(urlArray);
							var picObj = { photos: urlArray };
							FireFetch.UpdateInDB("Groups", groupID, picObj)
						});
				});
			})
		}
	}

	console.log(props);
	if (isLookupLoading) {
		return <Skeleton active paragraph={{ rows: 14 }} />;
	}

	return (
		<>
			<MDBCol md={12}>
				<Form
					form={form}
					layout="vertical"
					onFinish={editGroup}
					initialValues={{
						organisation: props.group?.organisation,
						community: props.group?.community,
						country: props.group?.country,
						district: props.group?.district,
						groupType: props.group?.groupType,
						genderDemographics: props.group?.genderDemographics,
						groupCallsSelf: props.group?.groupCallsSelf,
						responsibleUser: props.group?.responsibleUser,
						groupStartDate: moment(props.group?.groupStartDate, "YYYY"),
						groupEndDate: props.group?.groupEndDate !== "" ? moment(props.group?.groupEndDate, "YYYY-MM-DD") : null,
						groupPrimaryLanguage: props.group?.groupPrimaryLanguage,
						groupPurposeObjective: props.group?.groupPurposeObjective,
						activeMen: props.group?.activeMen,
						activeWomen: props.group?.activeWomen,
						meetingDays: props.group?.meetingDays,
						hasCompletedByLaws: props.group?.hasCompletedByLaws,
						groupStatus: props.group?.groupStatus,
						marketDay: props.group?.marketDay,
						notes: props.group?.notes,
						salesforceID: props.group?.salesforceID,
						primaryContactName: props.group?.primaryContactName,
						secondaryContactName: props.group?.secondaryContactName,
						secondaryGroupActivities: props.group?.secondaryGroupActivities,
						activeDisabled: props.group?.activeDisabled,
					}}
				>
					<Form.Item label="Organization"
						name="organisation"
						rules={[{
							required: true,
							message: 'Please select organisation!'
						}]}
					>
						<Select placeholder="Select group organisation"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{orgArray?.map((item, index) => (
								<Select.Option key={index} value={item?.id ?? item?.orgID}>
									{item?.name ?? item?.orgName ?? "-"}
								</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Community"
						name="community"
						rules={[{ required: true, message: 'Please input community!' }]}>
						<Select placeholder="Select group community"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
							onChange={communityChange}>
							{communityArray?.map((item, index) => (
								<Select.Option key={index} value={item?.id ?? item?.communityID}>
									{item?.name ?? item?.communityName ?? "-"}
								</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item
						label="Country"
						name="country"
						rules={[{ required: true, message: 'Please input country!' }
						]}>
						<Select placeholder="select Country"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{countries?.map((item, index) => (
								<Select.Option key={index} value={item?.id ?? `${item?.countryName ?? item?.name ?? "Unknown"}-${item?.alpha3Code ?? ""}`}>
									{item?.countryName ?? item?.name ?? "-"}
								</Select.Option>
							))}

						</Select>

					</Form.Item>
					<Form.Item
						label="District"
						name="district">
						<Select placeholder="Select District"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{districts?.map((item, index) => (
								<Select.Option key={index} value={item?.id ?? item?.districtID}>
									{`${item?.districtName ?? item?.district ?? "-"}-${item?.provinceID ?? item?.province ?? ""}`}
								</Select.Option>
							))}

						</Select>

					</Form.Item>
					<Form.Item label="Group Type"
						name="groupType"
						rules={[{ required: true, message: 'Please input group type!' }]}>
						<Select placeholder="Select group type"
							showSearch
							onChange={setSelectedType}
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{groupTypes?.map((item, index) => (
								<Select.Option key={index} value={item?.id ?? item?.typeID}>
									{item?.typeName ?? item?.type ?? "-"}
								</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Secondary Group Activities" name={"secondaryGroupActivities"}>
						<Checkbox.Group options={checkTypeList} onChange={onChange} />
					</Form.Item>
					<Form.Item label="Gender Demographics"
						name="genderDemographics"
						rules={[{ required: true, message: 'Please select gender!' }]}>
						<Select placeholder="Select group gender demographics"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Male", "Female", "Mixed"]?.map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="What does the group call itself?"
						name="groupCallsSelf">
						<Input placeholder="enter what the group calls itself" id="callsSelf" />
					</Form.Item>

					<Form.Item label="Responsible User"
						name="responsibleUser"
						rules={[{
							required: true,
							message: 'Please select responsible user!'
						}]}
					>
						<Select placeholder="Select group's responsible User"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{users?.filter((x) => isActiveUserStatus(x.userStatus))?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item
						label="Year established"
						name="groupStartDate"
						rules={[{
							required: true,
							message: 'Please input year!'
						}]}>
						<DatePicker
							placeholder="select group's starting year"
							picker={"year"}
							className="w-100" />

					</Form.Item>
					<Form.Item
						label="Group End Date (If no longer active)"
						name="groupEndDate">
						<DatePicker
							placeholder="select group's end date"
							picker={"date"}
							className="w-100" />

					</Form.Item>
					<Form.Item label="Group Primary Language" name="groupPrimaryLanguage">
						<Select placeholder="Select group primary language"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{languageArray?.map((item, index) => (
								<Select.Option key={index} value={item?.id ?? item?.languageID}>
									{item?.languageName ?? item?.language ?? "-"}
								</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item
						label="Group Purpose Objective"
						name="groupPurposeObjective">
						<TextArea type="text"
							placeholder="enter group's purpose objective"
							className="w-100 mr-4"
							id="objective" />

					</Form.Item>
					<Form.Item label="Active Men" name="activeMen"
						rules={[
							{
								//required: true,
								pattern: new RegExp(/\d+/),
								message: "Wrong number format!"
							}
						]}>
						<Input type="number" placeholder="enter number of active Men" />
					</Form.Item>
					<Form.Item label="Active Women" name="activeWomen"
						rules={[
							{
								//required: true,
								pattern: new RegExp(/\d+/),
								message: "Wrong number format!"
							}
						]}>
						<Input type="number" placeholder="enter number of active Women" />
					</Form.Item>
					<Form.Item label="Active Disabled" name="activeDisabled"
						rules={[
							{
								//required: true,
								pattern: new RegExp(/\d+/),
								message: "Wrong number format!"
							}
						]}>
						<Input type="number" placeholder="enter number of active Disabled People" />
					</Form.Item>
					<Form.Item label="Group Meeting Days" name="meetingDays">
						<Select placeholder="Select Meeting Day(s)"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{marketDays?.map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item
						label="Has Completed ByLaws"
						name="hasCompletedByLaws">
						<Radio.Group onChange={onRadioChange} value={radioValue}>
							<Radio value={"No"}>No</Radio>
							<Radio value={"Yes"}>Yes</Radio>
						</Radio.Group>
					</Form.Item>
					<Form.Item label="Group Status"
						name="groupStatus">
						<Select placeholder="Select group status"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{["Active", "Inactive", "Terminated"]?.map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>
					<Form.Item label="Market Day" name="marketDay">
						<Select placeholder="Select Market Day(s)"
							mode="multiple"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{marketDays?.map((item, index) => (
								<Select.Option key={index} value={item}>{item}</Select.Option>
							))}

						</Select>
					</Form.Item>

					<Form.Item
						label="Notes"
						name="notes">
						<TextArea type="text"
							placeholder="enter notes"
							className="w-100 mr-4"
							id="notes" />

					</Form.Item>
					<Form.Item
						label="Salesforce ID"
						name="salesforceID">
						<Input type="text"
							placeholder="enter Community SalesForce ID"
							className="w-100 mr-4"
							id="salesforce" />
					</Form.Item>
					<Divider orientation="left">
						Primary Contact Section
					</Divider>
					<Form.Item label="Primary Contact Name"
						name="primaryContactName"
						rules={[{
							required: true,
							message: 'Please select primary contact name!'
						}]}
					>
						{
							notListed ?

								<Input placeholder="enter primary contact name" id="primaryContact" />
								:
								<Select placeholder="Select group's primary contact"
									showSearch
									optionFilterProp="children"
									filterOption={filterSelectOption}
									filterSort={sortSelectOptions}
									onChange={(option) => {
										console.log(option)
										if (option === "Not Listed") {
											setNotListed(true);
											form.setFieldsValue({ primaryContactName: "" })
										} else {
											//setNotListed(false);
										}
									}}
								>
									{userArray?.filter((x) => isActiveUserStatus(x.userStatus))?.map((item, index) => (
										<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
									))}

								</Select>
						}
					</Form.Item>


					<Form.Item label="Secondary Contact Name"
						name="secondaryContactName"
					>
						{
							notListed2 ?

								<Input placeholder="enter secondary contact name" id="secondaryContact" />
								:
								<Select placeholder="Select group's secondary contact"
									showSearch
									optionFilterProp="children"
									filterOption={filterSelectOption}
									filterSort={sortSelectOptions}
									onChange={(option) => {
										if (option === "Not Listed") {
											setNotListed2(true);
											form.setFieldsValue({ secondaryContactName: "" })
										} else {
											//setNotListed2(false);
										}
									}}
								>
									{userArray?.filter((x) => isActiveUserStatus(x.userStatus))?.map((item, index) => (
										<Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
									))}

								</Select>
						}

					</Form.Item>
					<Form.Item
						label="Image 1"
						name="image1">
						<input
							type="file"
							accept="image/*"
							onChange={handleFileUpload}
						/>
					</Form.Item>
					<Form.Item
						label="Image 2"
						name="image2">
						<input
							type="file"
							accept="image/*"
							onChange={handleFileUpload}
						/>
					</Form.Item>

					<Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canUpdateGroup}>
						Edit
					</Button>

				</Form>
			</MDBCol>
		</>
	)
}

export default EditGroup;
